import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.ProfileModule.PendingPracticeInvitationRow', {
    invitationFrom: 'Invitation from {name} ({email})',
});
